/* Clean River shared behaviour: scroll reveal + carousels. Loaded on every page. */
(function(){
  function init(){
    document.querySelectorAll('.crx').forEach(function(root){
      root.querySelectorAll('[data-track]').forEach(function(track){
        var nav=track.parentElement.querySelector('.crx-nav')||root.querySelector('.crx-nav');
        if(!nav) return;
        nav.querySelectorAll('button').forEach(function(b){
          b.addEventListener('click',function(){var s=track.firstElementChild;var w=s?s.getBoundingClientRect().width+20:300;track.scrollBy({left:w*Number(b.dataset.dir),behavior:'smooth'});});
        });
      });
      if(!('IntersectionObserver' in window)) return;
      root.classList.add('crx-js');
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -40px 0px'});
      root.querySelectorAll('.rv').forEach(function(el){io.observe(el);});
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
